export default __webpack_public_path__ + "static/media/Pin_fill.3d2b3065.svg";